import { atsApiQuery, apiQuery } from '../';

export const interviewAtsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllInterview: builder.query({
        transformResponse: (response) => ({
          interviews: response.data?.interviews || [],
          pagination: response?.data?.pagination || {},
        }),
        query: ({ params }) => {
          return {
            method: 'get',
            url: `/ats_interviews`,
            params,
          };
        },
      }),
      getInterviewById: builder.query({
        providesTags: ['GetInterviewById'],
        transformResponse: (response) => response.data,
        query: ({ interviewId }) => {
          return {
            method: 'get',
            url: `/ats_interviews/${interviewId}`,
          };
        },
      }),

      fillScoreCardWithAi: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({
          applicantId,
          scorecardId,
          ats_interview_id,
          user_description = '',
          draft_answers,
        }) => {
          return {
            method: 'post',
            url: `ats_applications/${applicantId}/ats_scorecards/${scorecardId}/fill_with_ai`,
            data: {
              ats_interview_id,
              user_description,
              ...(draft_answers ? { draft_answers } : {}),
            },
          };
        },
      }),

      rewriteScoreCardWithAi: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ applicantId, scorecardId, payload }) => {
          return {
            method: 'post',
            url: `ats_applications/${applicantId}/ats_scorecards/${scorecardId}/rewrite_with_ai`,
            data: payload,
          };
        },
      }),

      pollScoreCardWithAi: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ applicantId, scorecardId, msg_id }) => {
          return {
            method: 'post',
            url: `ats_applications/${applicantId}/ats_scorecards/${scorecardId}/ai_results`,
            data: {
              msg_id,
            },
          };
        },
      }),
      scorecardRemainder: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ id }) => {
          return {
            method: 'post',
            url: `ats_scorecards/${id}/reminder`,
          };
        },
      }),
      editScoreCard: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ applicantId, scorecardId, payload }) => {
          return {
            method: 'patch',
            url: `ats_applications/${applicantId}/ats_scorecards/${scorecardId}`,
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetInterviewById' }];
          }
          return [];
        },
      }),
      createInterviewNote: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ interviewId, payload }) => {
          return {
            url: `ats_interviews/${interviewId}/notes`,
            method: 'post',
            data: payload,
          };
        },
      }),

      updateInterviewNote: builder?.mutation({
        transformResponse: (response) => response?.data,
        query: ({ interviewId, payload, noteId }) => {
          return {
            url: `ats_interviews/${interviewId}/notes/${noteId}`,
            method: 'patch',
            data: payload,
          };
        },
      }),
      getInterviewNotes: builder.mutation({
        transformResponse: (response) => response,
        query: ({ interviewId, params }) => {
          return {
            url: `/ats_interviews/${interviewId}/notes`,
            method: 'get',
            params,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetAllInterviewQuery,
  useLazyGetInterviewByIdQuery,
  useFillScoreCardWithAiMutation,
  useScorecardRemainderMutation,
  usePollScoreCardWithAiMutation,
  useEditScoreCardMutation,
  useRewriteScoreCardWithAiMutation,
  useCreateInterviewNoteMutation,
  useUpdateInterviewNoteMutation,
  useGetInterviewNotesMutation,
} = interviewAtsApi;

export const interviewApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getInterviewTranscript: builder.query({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}/transcript`,
          };
        },
      }),
      getInterviewSummary: builder.query({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}/ai_notes`,
          };
        },
      }),
      generateSummary: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId, ...rest } = payload;
          return {
            method: 'post',
            url: `/interviews/${interviewId}/ai_notes`,
            data: rest,
          };
        },
      }),
      getInterviewNote: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { interviewId, noteId } = payload;
          return {
            method: 'get',
            url: `/interviews/${interviewId}/ai_notes/${noteId}`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetInterviewTranscriptQuery,
  useLazyGetInterviewSummaryQuery,
  useGenerateSummaryMutation,
  useGetInterviewNoteMutation,
} = interviewApi;
